import {Component, ElementRef, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-modal-ausencia',
  templateUrl: './ausencia.component.html',
  styleUrls: ['./ausencia.component.scss'],
})
export class AusenciaComponent {
  @ViewChild('valor', {read: ElementRef, static: true}) valor: ElementRef;

  constructor(
    public modalCtrl: ModalController
  ) {}

  aceptar = () => this.modalCtrl.dismiss(this.valor.nativeElement.value);

}
